import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import DesktopResponsive from './responsive/AgenticCommerce/DesktopResponsive';
import MobileResponsive from './responsive/AgenticCommerce/MobileResponsive';

class AgenticCommerce extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Agentic Commerce | EditPage</title>
          <meta
            content="EditPage Agentic Commerce helps teams plan campaigns, publish updates, and optimize conversion with connected MCP workflows."
            name="description"
          />
          <meta content="EditPage" name="generator" />
          <link rel="canonical" href="https://www.editpage.com/agentic-commerce" />
        </Helmet>
        <DesktopResponsive history={this.props.history} />
        <MobileResponsive history={this.props.history} />
      </div>
    );
  }
}

export default AgenticCommerce;
